import { MapItem } from '@capturum/ui/api';

export interface BaseDataValueMapItem extends MapItem {
  value_key: string;
  attributes?: any[];
}
